import { render, staticRenderFns } from "./ReviewInput.vue?vue&type=template&id=20e8b6e6&scoped=true&"
import script from "./ReviewInput.vue?vue&type=script&lang=js&"
export * from "./ReviewInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e8b6e6",
  null
  
)

export default component.exports